import { clubbiStyled } from 'clubbi-ui'

export const StyleContainerTag = clubbiStyled('div')(({ theme }) => ({
  font: theme.typography.fontSize4XS,
  fontWeight: 600,
  position: 'absolute',
  top: '95px',
  left: '8px',
  height: '20px',
  borderRadius: '2px',
  textAlign: 'center',
  padding: '0 5px',

  color: theme.palette.brandWhite.main,
  background: theme.palette.brandAlert[50],

  [theme.breakpoints.up('sm')]: {
    font: theme.typography.fontSize3XS,
    top: '135px',
    left: '20px',
    height: '22px',
  },
}))
